import { createApi } from '@reduxjs/toolkit/query/react'

import { CONSTS } from '../config/objectConst'
import { axiosBaseQuery } from './utils/rtk'

export const enum Tag {
	Executions = 'E',
	Subscription = 'S',
	TeamMembers = 'TM',
	WorkspaceStats = 'WS'
}

export const apiRTK = createApi({
	baseQuery: axiosBaseQuery({
		baseUrl: CONSTS.API.URL
	}),
	endpoints: () => ({}),
	reducerPath: 'api',
	tagTypes: [
		Tag.Subscription,
		Tag.WorkspaceStats,
		Tag.TeamMembers,
		Tag.Executions
	]
})
